import React from "react";
import InputWithLabel from "./InputWithLabel";

export default (props) => (
    <InputWithLabel label={props.children}
                    value={props[props.attribute]}
                    inputId={props.attribute}
                    type="text"
                    onChange={value => props.onAttributesChange({ [props.attribute]: value })}
                    highlightError={props.attributesWithErrors.includes(props.attribute)} />
);



/** WEBPACK FOOTER **
 ** ./src/main/javascript/authentication/components/TextInput.js
 **/